// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__g30WU","title":"styles_title__liNFB","description":"styles_description__8Hh9R","content":"styles_content__YDmxA"};